import { FC, ReactNode } from 'react';
import cn from 'classnames';
import NextImage from 'src/shared-components/NextImage/NextImage';

export type navigationOptions = {
  id: string;
  iconProps?: {
    src: string;
    width: number;
    height: number;
    alt: string;
  };
  label: JSX.Element;
};

interface Props {
  navigationOptions: navigationOptions[];
  title: ReactNode;
  handleIdChange: (id: string) => void;
  handleSelected?: (id: string) => boolean;
}
const NavigationWidget: FC<Props> = ({
  navigationOptions,
  title,
  handleIdChange,
  handleSelected
}) => {
  return (
    <div className="relative overflow-hidden w-[300px] bg-gallery rounded-2xl hidden sm:flex flex-col">
      <div className="bg-astronautBlue flex text-white items-center justify-center fs-body-lg-bold uppercase py-4">
        <p>{title}</p>
      </div>
      {navigationOptions.map((option) => {
        const isSelected = handleSelected(option.id);

        return (
          <button
            key={option.id}
            disabled={isSelected}
            onClick={() => handleIdChange(option.id)}
            className={cn(
              'flex w-full relative items-center text-left leading-4 h-16 uppercase border-b border-white last:border:none px-[22px]',
              isSelected ? 'text-vermilion fs-body-bold' : 'text-mako '
            )}
          >
            {option?.iconProps && (
              <div className="pr-[34px]">
                <NextImage {...option.iconProps} />
              </div>
            )}
            <p className="z-10">{option.label}</p>
          </button>
        );
      })}
    </div>
  );
};

export default NavigationWidget;
